module.exports = __webpack_public_path__ + "static/Neutraface-Slab-Text-Book-6283216c75079d88638b316ad7b25f39.otf";